//#region src/verticals/booking/BookingEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.ListingViewed = "booking.listing.viewed", e.SearchInitiated = "booking.search.initiated", e.SearchResultsViewed = "booking.search_results.viewed", e.BookNowClicked = "booking.cta.book_now_clicked", e.Confirmed = "booking.booking.confirmed", e.Cancelled = "booking.booking.cancelled", e.SearchPageViewed = "booking.page.search_viewed", e.ListingPageViewed = "booking.page.listing_viewed", e;
}({});
//#endregion
export { e as BookingEvent };
